module.exports = __webpack_public_path__ + "static/media/laravel_development.97b8ee04.svg";